/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactListFromJSON, ContactListToJSON } from './ContactList';
export function GetContactListsResponseDataFromJSON(json) {
    return GetContactListsResponseDataFromJSONTyped(json, false);
}
export function GetContactListsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactLists: !exists(json, 'contact_lists')
            ? undefined
            : json['contact_lists'].map(ContactListFromJSON)
    };
}
export function GetContactListsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_lists: value.contactLists === undefined ? undefined : value.contactLists.map(ContactListToJSON)
    };
}
